import { http, HttpResponse } from 'msw';
import { servicesMocks } from '../mocks';

export const servicesHandler = http.get('*/services', () =>
  HttpResponse.json(servicesMocks.services)
);

export const optionsHandler = http.post('*/balance/credit/options', () =>
  HttpResponse.json(servicesMocks.options)
);
